import { createReducer } from 'deox'
import {
  setAllocationIndexClaiming,
  setAllocationOpenTabs,
  setAllPoolsLastPage,
  setBottomNavButton,
  setDiscordWarningNotice,
  setDismissableModal,
  setHasCompletedPlusCheckout,
  setHeaderBgUrl,
  setHeaderHeight,
  setHideBurger,
  setInvestmentAmountForCheckout,
  setIsCheckoutScreen,
  setIsDarkThemeState,
  setIsDrops,
  setIsLaunch,
  setIsMemecoins,
  setMemecoinsSearchQuery,
  setMultiStepTxCurrentStep,
  setMultiStepTxTotalSteps,
  setPageBgUrl,
  setPlanForCheckout,
  setReferralProject,
  setReferralProjectData,
  setReferralProjectError,
  setReferralProjectLoading,
  setResetAllClaims,
  setRewardsAmount,
  setShouldResetRewardsNotification,
  setShouldScrollToProjects,
  setShouldShowDashboardHeaderGradient,
  setShowHeaderGradient,
  setShowRadialGlow,
  setTopBarContent,
  setTopBarHideMobile,
  setTopBarRightContent,
  setTopBarUrlLink,
  setTwitterWarningNotice,
} from './actions'
import { MiscUI } from '../../types/reducerTypes'

export const initialState: MiscUI = {
  headerBgUrl: '',
  pageBgUrl: '',
  isDarkTheme: true,
  hideBurger: false,
  topBarContent: null,
  topBarUrlLink: null,
  allPoolsLastPage: 0,
  shouldScrollToProjects: false,
  shouldResetRewardsNotification: false,
  multiStepTxCurrentStep: 0,
  multiStepTxTotalSteps: 1,
  allocationOpenTabs: [],
  resetAllClaims: false,
  allocationIndexClaiming: -1,
  topBarRightContent: false,
  topBarHideMobile: false,
  investmentAmountForCheckout: 0,
  isCheckoutScreen: false,
  planForCheckout: {
    name: 'No Plan',
    required: '0',
    allocation: '0',
    lockInPeriod: 0,
  },
  hasCompletedPlusCheckout: false,
  showRadialGlow: true,
  rewardsAmount: 0,
  headerHeight: 0,
  showHeaderGradient: false,
  showDashboardHeaderGradient: false,
  isLaunch: false,
  isMemecoins: false,
  isDrops: false,
  referralProject: undefined,
  twitterWarningNotice: null,
  discordWarningNotice: null,
  bottomNavButton: null,
  memecoinsSearchQuery: '',
  dismissableModal: null,
}

const miscUiReducer = createReducer(initialState, (handleAction) => {
  return [
    handleAction(setHeaderBgUrl, (state, { payload }) => ({
      ...state,
      headerBgUrl: payload,
    })),
    handleAction(setHideBurger, (state, { payload }) => ({
      ...state,
      hideBurger: payload,
    })),
    handleAction(setPageBgUrl, (state, { payload }) => ({
      ...state,
      pageBgUrl: payload,
    })),
    handleAction(setIsDarkThemeState, (state, { payload }) => ({
      ...state,
      isDarkTheme: payload,
    })),
    handleAction(setTopBarContent, (state, { payload }) => ({
      ...state,
      topBarContent: payload,
    })),
    handleAction(setTopBarUrlLink, (state, { payload }) => ({
      ...state,
      topBarUrlLink: payload,
    })),
    handleAction(setTopBarRightContent, (state, { payload }) => ({
      ...state,
      topBarRightContent: payload,
    })),
    handleAction(setTopBarHideMobile, (state, { payload }) => ({
      ...state,
      topBarHideMobile: payload,
    })),
    handleAction(setAllPoolsLastPage, (state, { payload }) => ({
      ...state,
      allPoolsLastPage: payload,
    })),
    handleAction(setShouldScrollToProjects, (state, { payload }) => ({
      ...state,
      shouldScrollToProjects: payload,
    })),
    handleAction(setShouldResetRewardsNotification, (state, { payload }) => ({
      ...state,
      shouldResetRewardsNotification: payload,
    })),
    handleAction(setMultiStepTxTotalSteps, (state, { payload }) => ({
      ...state,
      multiStepTxTotalSteps: payload,
    })),
    handleAction(setMultiStepTxCurrentStep, (state, { payload }) => ({
      ...state,
      multiStepTxCurrentStep: payload,
    })),
    handleAction(setAllocationOpenTabs, (state, { payload }) => ({
      ...state,
      allocationOpenTabs: payload,
    })),
    handleAction(setResetAllClaims, (state, { payload }) => ({
      ...state,
      resetAllClaims: payload,
    })),
    handleAction(setAllocationIndexClaiming, (state, { payload }) => ({
      ...state,
      allocationIndexClaiming: payload,
    })),
    handleAction(setInvestmentAmountForCheckout, (state, { payload }) => ({
      ...state,
      investmentAmountForCheckout: payload,
    })),
    handleAction(setIsCheckoutScreen, (state, { payload }) => ({
      ...state,
      isCheckoutScreen: payload,
    })),
    handleAction(setPlanForCheckout, (state, { payload }) => ({
      ...state,
      planForCheckout: payload,
    })),
    handleAction(setHasCompletedPlusCheckout, (state, { payload }) => ({
      ...state,
      hasCompletedPlusCheckout: payload,
    })),
    handleAction(setShowRadialGlow, (state, { payload }) => ({
      ...state,
      showRadialGlow: payload,
    })),
    handleAction(setRewardsAmount, (state, { payload }) => ({
      ...state,
      rewardsAmount: payload,
    })),
    handleAction(setHeaderHeight, (state, { payload }) => ({
      ...state,
      headerHeight: payload,
    })),
    handleAction(setShowHeaderGradient, (state, { payload }) => ({
      ...state,
      showHeaderGradient: payload,
    })),
    handleAction(setIsLaunch, (state, { payload }) => ({
      ...state,
      isLaunch: payload,
    })),
    handleAction(setIsMemecoins, (state, { payload }) => ({
      ...state,
      isMemecoins: payload,
    })),
    handleAction(setMemecoinsSearchQuery, (state, { payload }) => ({
      ...state,
      memecoinsSearchQuery: payload,
    })),
    handleAction(setIsDrops, (state, { payload }) => ({
      ...state,
      isDrops: payload,
    })),
    handleAction(
      setShouldShowDashboardHeaderGradient,
      (state, { payload }) => ({
        ...state,
        showDashboardHeaderGradient: payload,
      }),
    ),
    handleAction(setReferralProject, (state, { payload }) => ({
      ...state,
      referralProject: payload,
    })),
    handleAction(setReferralProjectData, (state, { payload }) => ({
      ...state,
      referralProject: {
        ...state?.referralProject,
        data: payload,
      },
    })),
    handleAction(setReferralProjectLoading, (state, { payload }) => ({
      ...state,
      referralProject: {
        ...state?.referralProject,
        isLoading: payload,
      },
    })),
    handleAction(setReferralProjectError, (state, { payload }) => ({
      ...state,
      referralProject: {
        ...state?.referralProject,
        isError: payload,
      },
    })),
    handleAction(setTwitterWarningNotice, (state, { payload }) => ({
      ...state,
      twitterWarningNotice: payload,
    })),
    handleAction(setDiscordWarningNotice, (state, { payload }) => ({
      ...state,
      discordWarningNotice: payload,
    })),
    handleAction(setBottomNavButton, (state, { payload }) => ({
      ...state,
      bottomNavButton: payload,
    })),
    handleAction(setDismissableModal, (state, { payload }) => ({
      ...state,
      dismissableModal: payload,
    })),
  ]
})

export default miscUiReducer
